import { SrInsightType as InsightType } from '@plato/data/starrocks/types';
import type { Namespace, TFunction } from 'i18next';
import type { InsightDTO, ResolvedOutcomeInsightDTO } from '../../../server/dto/insight-dto.ts';
import { churnV2CardDimension } from '../components/churn-v2-dimension.ts';

export function getInsightName(
    t: TFunction<Namespace>,
    insight: InsightDTO | ResolvedOutcomeInsightDTO,
): string {
    if (insight.insight_type === InsightType.INDUSTRY_TOP) {
        return t('insight_name__IndustryTopCategory', {
            ns: 'insights',
            industry_sector: insight.template_arguments?.industry_sector,
        });
    }

    if (insight.insight_type === InsightType.CHURN_WARNING) {
        const args = insight.template_arguments;
        // Only v2 churn carries dimensions; v1 and resolved outcomes get the generic name.
        // Same selector as the tooltip and body text, so the heading cannot contradict them.
        const dim = args && 'top_dimension_1' in args ? churnV2CardDimension(args) : undefined;

        switch (dim) {
            case 'd1_silence':
                return t('churn_v2_title__d1_silence', { ns: 'insights' });
            case 'd2_cadence':
                return t('churn_v2_title__d2_cadence', { ns: 'insights' });
            case 'd3_annual':
                return t('churn_v2_title__d3_annual', { ns: 'insights' });
            case 'd4_seasonal':
                return t('churn_v2_title__d4_seasonal', { ns: 'insights' });
            case 'd5_revenue':
                return t('churn_v2_title__d5_revenue', { ns: 'insights' });
            case 'd6_momentum':
                return t('churn_v2_title__d6_momentum', { ns: 'insights' });
            case 'd7_concentration':
                return t('churn_v2_title__d7_concentration', { ns: 'insights' });
            case 'd8_global':
                return t('churn_v2_title__d8_global', { ns: 'insights' });
            case undefined:
                return t('insight_name__ChurnWarningWebCategory', { ns: 'insights' });
        }
    }

    switch (insight.insight_type) {
        case InsightType.GLOBAL_CHURN_WARNING:
            return t('insight_name__GlobalChurnWarning', { ns: 'insights' });
        case InsightType.CROSS_SELL:
            return t('insight_name__XSellWebCategory', { ns: 'insights' });
        case InsightType.FIRST_PURCHASE:
            return t('insight_name__FirstPurchaseWebCat3', { ns: 'insights' });
        case InsightType.GLOBAL_TOP:
            return t('insight_name__GlobalTopCategory', { ns: 'insights' });
        case InsightType.PREVIOUSLY_PURCHASED:
            return t('insight_name__PreviouslyPurchasedCategory', { ns: 'insights' });
        case InsightType.SHARE_OF_WALLET:
            return t('insight_name__ShareOfWalletCategory', { ns: 'insights' });
    }
}
